import { CustomBottomBar } from '@components';
import { Button, Container, Dropdown, Separator, Typography } from '@design-system';
import { useWorksiteSelectionPageVM } from './useWorksiteSelectionPageVM';
import './WorksiteSelectionPage.scss';

export const WorksiteSelectionPage: React.FC = () => {
    const {
        operatorsOptions,
        worksitesOptions,
        selectedOperatorId,
        handleOperatorChange,
        worksiteId,
        setWorksiteId,
        handleContinue,
        canContinue
    } = useWorksiteSelectionPageVM();

    return (
        <div className="worksite-selection-page">
            <Container>
                <Container bordered="grey" className="selection-container">
                    <Typography intrinsic="h3" defaultSpacing>
                        Sélection du chantier
                    </Typography>
                    <Typography intrinsic="p" defaultSpacing>
                        Avant de commencer l'accueil sécurité, veuillez sélectionner le conducteur de travaux et le chantier concerné.
                    </Typography>

                    <Separator className="opa-0" />

                    <Dropdown
                        options={operatorsOptions}
                        placeholder="Conducteur de travaux"
                        onOptionChange={(option) => handleOperatorChange(option.id)}
                        value={operatorsOptions.find((operator) => operator.id === selectedOperatorId) || null}
                        isSearchable={true}
                    />

                    <Separator className="opa-0" />

                    <Dropdown
                        options={worksitesOptions}
                        placeholder="Chantier"
                        onOptionChange={(option) => setWorksiteId(Number(option.id))}
                        value={
                            worksiteId && worksitesOptions.length > 0
                                ? worksitesOptions.find((worksite) => worksite.id === worksiteId.toString()) || null
                                : null
                        }
                        disabled={!selectedOperatorId}
                        isSearchable={true}
                    />
                </Container>
            </Container>

            <CustomBottomBar>
                <Button variant="primary" color="marine" size="fullwidth" disabled={!canContinue} onClick={handleContinue}>
                    <Typography intrinsic="h4">Continuer</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
